import React from 'react';
import './App.css';
import SongBox from "./Containers/SongBox"

function App() {
  return (
    <div className="App">
      <SongBox />
    </div>
  );
}

export default App;
